import { DialogProvider } from "components/dialog/controller/DialogProvider";
import { ReactNode } from "react";
import { CookiesProvider } from "react-cookie";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

type Props = { children: ReactNode };

export const Providers = ({ children }: Props) => {
  return (
    <CookiesProvider>
      <DndProvider backend={HTML5Backend}>
        <DialogProvider>{children}</DialogProvider>
      </DndProvider>
    </CookiesProvider>
  );
};
